export const IMPERSONATION_BLOCKED_CODE = 'IMPERSONATION_BLOCKED';
export const IMPERSONATION_BLOCKED_MESSAGE_ID = 'impersonation.actionDisabled';

export const isImpersonationBlockedCode = (code?: string | null): boolean => code === IMPERSONATION_BLOCKED_CODE;
